// หน้าเข้าสู่ระบบ — SSO อย่างเดียว
//
// ช่องกรอกรหัสพนักงานถูกถอดออกแล้ว: token ที่ Wazzup ออกให้ IAM ไม่รับ ทำให้ server
// ระบุตัวตนคนที่เข้าทางนั้นไม่ได้ (resolveCaller คืน null) แล้วถูกกรองแบรนด์เหลือศูนย์
// ทางเดียวที่ทุกส่วนของระบบรู้จักผู้ใช้ตรงกันคือ token ที่ออกโดย IAM
import { getSsoOutcome, startSsoLogin } from "../lib/iam-sso";

export function StaffLogin({
  message,
  next,
  standalone = false,
}: {
  message?: string;
  /** หน้าที่จะพากลับไปหลัง login สำเร็จ (มาจาก ?next= ของ RequireSession) */
  next?: string;
  /** true = ใช้เป็นหน้าเต็ม ไม่ใช่การ์ดในหน้า Setting → Staff */
  standalone?: boolean;
}) {
  // กลับมาจาก IAM แล้วไม่ผ่าน (state ไม่ตรง / token หมดอายุ) — บอกเหตุแล้วให้กดเริ่มใหม่
  // ห้ามพากลับไป authorize เอง ไม่งั้นจะวนไม่จบเมื่อ error ค้าง
  const sso = getSsoOutcome();
  const ssoError = sso.kind === "error" ? sso.message : null;

  return (
    <>
      <div className="content-head">
        <div>
          {standalone ? (
            <>
              <div className="breadcrumb">Agency Intelligence</div>
              <h1>เข้าสู่ระบบ</h1>
            </>
          ) : (
            <>
              <div className="breadcrumb">Setting / Staff</div>
              <h1>Staff</h1>
            </>
          )}
        </div>
      </div>
      <div className="panel login-card">
        <h3>เข้าสู่ระบบ</h3>
        <p className="muted">
          {standalone
            ? "ระบบนี้ดึงข้อมูลจาก Inbox Center · KOL Report · Biddable ด้วยบัญชีของคุณเอง จึงต้องเข้าสู่ระบบก่อน"
            : "ต้องเข้าสู่ระบบด้วยบัญชีพนักงานก่อน จึงจะดูรายชื่อพนักงานได้"}
        </p>
        {message && <p className="error-text">{message}</p>}
        {ssoError && <p className="error-text">{ssoError}</p>}

        <button type="button" className="btn-primary sso-btn" onClick={() => startSsoLogin(next)}>
          เข้าสู่ระบบด้วย SSO (บัญชีเดียวทุกระบบ)
        </button>
      </div>
    </>
  );
}
